import React from "react";
import { Shield } from "lucide-react";
import BaseTooltip from "@/components/reusables/BaseTooltip";
import { useTranslation } from "react-i18next";
import { useIsReservationsEnabled } from "@redux/features/companies/useIsReservationsEnabled";

interface ReservedQuantityIndicatorProps {
    reservedQuantity: number | null | undefined;
    placement?: "top" | "bottom" | "left" | "right";
}

export default function ReservedQuantityIndicator({
                                                            reservedQuantity,
                                                            placement = "top",
                                                        }: ReservedQuantityIndicatorProps) {
    const { t } = useTranslation("", { keyPrefix: "general.components.reservedQuantityIndicator" });

    const isReservationsEnabled = useIsReservationsEnabled();

    if (!isReservationsEnabled || !reservedQuantity) {
        return null;
    }

    return (
        <BaseTooltip
            title={t("tooltip", { count: reservedQuantity }) as string}
            placement={placement}
        >
            <div
                className="inline-flex items-center rounded-xl px-2 p-1 border border-solid text-xs text-accent relative"
                style={{
                    backgroundColor: "#FBFBFB",
                    borderColor: "#E4E4E4",
                }}
            >
                <Shield
                    className="text-[#A6DD4C]"
                    size={14}
                />
                <span className="ml-[4px]">
                    {reservedQuantity}
                </span>
            </div>
        </BaseTooltip>
    );
}

